import React, { useCallback } from "react"
import ConversationsBrandSelector from "../conversations-brand-selector"
import SearchInput from "../form/search-input"
import List from "./list"
import ConversationFilter from "../conversation-filter"
import ConversationsStats from "../conversations-stats"
import {
  searchQuery as searchQueryStored,
  setSearchQuery
} from "../../../redux/slices/conversations"
import { Threads } from "../../../types"
import { useAppDispatch, useAppSelector } from "../../hooks"

interface Props {
  filteredThreads: Threads
  isLoading: boolean
}

const ConversationsList = ({ filteredThreads, isLoading }: Props) => {
  const dispatch = useAppDispatch()

  const searchQuery = useAppSelector(searchQueryStored)

  const handleSearchQueryChange = useCallback(
    (value: string) => {
      dispatch(setSearchQuery(value))
    },
    [dispatch]
  )

  //if (error) return <div>Error loading threads</div>

  return (
    <div className="w-screen sm:w-[367px] min-w-full sm:min-w-[367px] sm:max-w-[367px] bg-white border-r border-neutral-200 overflow-y-auto">
      <div className="sticky top-0 bg-white border-b border-neutral-200 z-10">
        <div className="p-4">
          <div className="flex items-center gap-3">
            <SearchInput
              disabled={isLoading}
              className="py-2"
              wrapperClassName="w-full"
              placeholder="Search Leads"
              value={searchQuery}
              onSearch={val => handleSearchQueryChange(val as string)}
            />
            <ConversationFilter />
          </div>
          <ConversationsBrandSelector />
        </div>
        <ConversationsStats />
      </div>

      <List isLoading={isLoading} filteredThreads={filteredThreads} />
    </div>
  )
}

export default ConversationsList
